export default {
    meta: {
        title: '开发测试页'
    }
};
